import { Flex, Pill } from "@mantine/core";
import type { JSX } from "react";
import classes from "./TimelineItem.module.css";
import type { MessageTagProps } from "./types";

export function TextMask({ children, isExpanded }: { isExpanded: boolean; children: React.ReactNode }): JSX.Element {
    const className = isExpanded ? classes.textMaskExpanded : classes.textMaskNotExpanded;
    return (
        <Flex className={className} direction="column">
            {children}
        </Flex>
    );
}

export function MessageTag({ tagName, type }: MessageTagProps): JSX.Element {
    const isSmartOffer = type === "SmartOffer";
    const tagClassName = isSmartOffer ? classes.smartOfferTag : classes.messageTag;

    return (
        <Pill className={tagClassName} size="xs">
            {tagName}
        </Pill>
    );
}
